
import { initInvestorCalendars } from "./../js/investorCalendars/initInvestorCalendars";

initInvestorCalendars("investor-calendar");
